export default __webpack_public_path__ + "static/media/iOS.ee157acf.svg";